import constants from '@/api';

const initialState = () => ({
	fileMetaEditorDialog: false,
	stockistMeta: {},
	selectedStockistMeta: {},
});
export default {
	namespaced: true,
	state: initialState(),
	mutations: {
		openFileMetaDialog(state) {
			state.fileMetaEditorDialog = true;
		},
		closeFileMetaDialog(state) {
			state.fileMetaEditorDialog = false;
		},
		loadStockistMeta(state, mm) {
			state.stockistMeta = JSON.parse(JSON.stringify(mm));
		},
		setSelectedStockistMeta(state, sf) {
			state.selectedStockistMeta = sf;
		},
		setCurrentLogs(state, logs) {
			state.currentLogs = logs;
		},
		refreshStockistListEmitter() {},
		failure: (s, msg) => {
			console.log('[failure] ', msg);
		},
		resetState(state) {
			const initial = initialState();
			Object.keys(initial).forEach(key => {
				state[key] = initial[key];
			});
		},
	},
	actions: {
		getStockistMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.STOCKIST,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						commit('loadStockistMeta', data.stockists);
						return data;
					} else {
						fail(data.message || 'Failed to load Mail meta');
						return false;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		updateStockistMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.UPDATE_STOCKIST_META,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						return true;
					} else {
						fail(data.message || 'Failed to Update Stockist meta');
						return false;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to Update Stockist meta');
				});
		},
		deleteStockistMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.DELETE_STOCKIST_META,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						return true;
					} else {
						fail(data.message || 'Failed to Delete Stockist meta');
						return false;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to Delete Stockist meta');
				});
		},
		correctMapping: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCallWithHeaderConfig',
				{
					partConfig: {
						method: 'post',
						data: payload,
						url: constants.UPLOAD_CORRECT_STOCKIST_MAPPING,
					},
					headerConfig: {
						'Content-Type': 'multipart/form-data',
					},
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						return data;
					} else {
						fail(data.message || 'Failed to Delete Stockist meta');
						return data;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to Delete Stockist meta');
				});
		},
		forcedMapping: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCallWithHeaderConfig',
				{
					partConfig: {
						method: 'post',
						data: payload,
						url: constants.UPLOAD_STOCKIST_MAPPING,
					},
					headerConfig: {
						'Content-Type': 'multipart/form-data',
					},
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						return data;
					} else {
						fail(data.message || 'Failed to Delete Stockist meta');
						return data;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to Delete Stockist meta');
				});
		},
		downloadStockistMappingErrors: ({ commit, dispatch }, file) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url: constants.DOWNLOAD_STOCKIST_MAPPING_ERROR,
					responseType: 'blob',
				},
				{ root: true }
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{ text: 'Starting Download' },
							{ root: true }
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'stockist-mapping-errors.csv'); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		downloadCorrectedStockistMappingErrors: ({ commit, dispatch }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url: constants.DOWNLOAD_CORRECT_STOCKIST_MAPPING_ERROR,
					responseType: 'blob',
				},
				{ root: true }
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{ text: 'Starting Download' },
							{ root: true }
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute(
							'download',
							'corrected-stockist-mapping-errors.csv'
						); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
	},
	getters: {
		fileMetaEditorDialog: state => state.fileMetaEditorDialog,
		stockistMeta: state => state.stockistMeta,
		selectedStockistMeta: state => state.selectedStockistMeta,
	},
};
